// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.selectitem[data-v-7bbcf62e] {\n  text-align: center;\n  padding: 8px;\n}\n.selectitem[data-v-7bbcf62e]:hover {\n  background: rgba(200, 200, 200, 0.5);\n}\n.edtcstselectitem[data-v-7bbcf62e]:focus {\n  outline: solid 1px #00000029;\n  box-shadow: 0px 3px 20px #00000029;\n}\n\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
